import { render, staticRenderFns } from "./CadastroAdmHotel.vue?vue&type=template&id=f8603366&scoped=true&class=template&"
import script from "./CadastroAdmHotel.vue?vue&type=script&lang=js&"
export * from "./CadastroAdmHotel.vue?vue&type=script&lang=js&"
import style0 from "./CadastroAdmHotel.vue?vue&type=style&index=0&id=f8603366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8603366",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VRow})
